import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Slider } from '../components/Slider';
import am2023_1 from "../images/Events/Alumni/am2023_1.jpeg";
import am2023_2 from "../images/Events/Alumni/am2023_2.jpeg";
import am2024_1 from "../images/Events/Alumni/am2024_1.jpeg";
import am2024_2 from "../images/Events/Alumni/am2024_2.jpeg";
import am2025_1 from "../images/Events/Alumni/am2025_1.jpeg";
import am2025_2 from "../images/Events/Alumni/am2025_2.jpeg";
function AlumniRegistrationForm() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [whatsappNumber, setWhatsappNumber] = useState("");
    const [yearOfPassing, setYearOfPassing] = useState("");
    const [emailError, setEmailError] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [occupation, setOccupation] = useState("");
    const [address, setAddress] = useState("");
    const [gender, setGender] = useState("");
    const [afterDiploma, setAfterDiploma] = useState("");
    const handleSubmit = (event) => {
        event.preventDefault();
    };

 

    return (
        <>
            <Slider />
            <div className="header-parent sticky top-0">
                {/* Header can be included here if needed */}
            </div>
            <br />
            <div className="   max-w-[80%] mx-auto p-4 " method="post" action="https://gpsakoli.ac.in/public/api/connection?action=insertAlumniDetails" onSubmit={handleSubmit}>
                <h1 className="heading text-center">Alumni <span className="heading-red">Association</span></h1>
                <br></br>
                <h1 className="heading heading-top-left-line">Photo Gallery </h1>
                <table><tr><td colSpan="2" className="heading text-center heading-red">Alumni Meet 2023</td></tr>
                <tr><td><div>
                            <img style={{ width: 800, height: 500 }} src={am2023_1} alt="" />
                        </div>
                        </td>
                        <td><div>
                                    <img style={{ width: 800, height: 500 }} src={am2023_2} alt="" />
                                </div>
                            </td>
                </tr>
                <tr><td colSpan="2" className="heading text-center heading-red">Alumni Meet 2024</td></tr>
                <tr><td><div>
                            <img style={{ width: 800, height: 500 }} src={am2024_1} alt="" />
                        </div>
                        </td>
                        <td><div>
                                    <img style={{ width: 800, height: 500 }} src={am2024_2} alt="" />
                                </div>
                            </td>
                </tr>
                <tr><td colSpan="2" className="heading text-center heading-red">Alumni Meet 2025</td></tr>
                <tr><td><div>
                            <img style={{ width: 800, height: 500 }} src={am2025_1} alt="" />
                        </div>
                        </td>
                        <td><div>
                                    <img style={{ width: 800, height: 500 }} src={am2025_2} alt="" />
                                </div>
                            </td>
                </tr>

                
                
                </table>
            </div>
        </>
    );
}

export default AlumniRegistrationForm;
